<template>
  <div>
    <h1>Vigenère-Chiffre</h1>
    <h2>Verschlüsselung</h2>
    <Vigenere mode="encrypt" />
    <h2>Entschlüsselung</h2>
    <Vigenere mode="decrypt" />
  </div>
</template>
<script>
import Vigenere from '@/components/Vigenere.vue'

export default {
  name: 'vigenere',
  components: {
    Vigenere
  }
}
</script>
